<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Invite access</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="SendIcon"
        :disabled="!body?.canSend || !!body?.sendInvitesLoading"
        class="pr-0.5"
        @click="body?.handleInviteClick()"
      />
    </template>

    <Sheet.Body class="pt-[25px]">
      <FileAccessBody ref="body" :file="file" hide-send-button />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon, SendIcon } from '@dacr/icons'
import type { File } from '@/shared/graphql/router/graphql'
import FileAccessBody from './FileAccessBody.vue'

defineProps<{
  file: File
}>()

const { close } = useSheet()

const body = ref<{
  handleInviteClick: () => void
  canSend: boolean
  sendInvitesLoading: boolean
} | null>(null)
</script>
